var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTasksDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 1.25H2.5625C2.1875 1.25 1.9375 1.5 1.9375 1.875V18.125C1.9375 18.5 2.1875 18.75 2.5625 18.75H17.4375C17.8125 18.75 18.0625 18.5 18.0625 18.125V1.875C18.0625 1.5 17.75 1.25 17.4375 1.25ZM16.8125 17.5H3.1875V2.5H16.8125V17.5Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.1875H15C15.375 6.1875 15.625 5.9375 15.625 5.5625C15.625 5.1875 15.375 4.9375 15 4.9375H10.625C10.25 4.9375 10 5.1875 10 5.5625C10 5.9375 10.25 6.1875 10.625 6.1875Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10.625H15C15.375 10.625 15.625 10.375 15.625 10C15.625 9.625 15.375 9.375 15 9.375H10.625C10.25 9.375 10 9.625 10 10C10 10.375 10.25 10.625 10.625 10.625Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.0625H15C15.375 15.0625 15.625 14.8125 15.625 14.4375C15.625 14.0625 15.375 13.8125 15 13.8125H10.625C10.25 13.8125 10 14.0625 10 14.4375C10 14.8125 10.25 15.0625 10.625 15.0625Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74997 16.0625C5.87497 16.1875 5.99997 16.25 6.18747 16.25C6.43747 16.25 6.49997 16.1875 6.62497 16.0625L9.12497 13.5625C9.37497 13.3125 9.37497 12.9375 9.12497 12.6875C8.87497 12.4375 8.49997 12.4375 8.24997 12.6875L6.24997 14.75L5.43747 13.8125C5.18747 13.5625 4.81247 13.5 4.56247 13.75C4.31247 14 4.24997 14.375 4.49997 14.625L5.74997 16.0625Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74997 11.625C5.87497 11.75 5.99997 11.8125 6.18747 11.8125C6.43747 11.8125 6.49997 11.75 6.62497 11.625L9.12497 9.125C9.37497 8.875 9.37497 8.5 9.12497 8.25C8.87497 8 8.49997 8 8.24997 8.25L6.24997 10.3125L5.43747 9.375C5.18747 9.125 4.81247 9.0625 4.56247 9.3125C4.31247 9.5625 4.24997 9.9375 4.49997 10.1875L5.74997 11.625Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74997 7.25C5.87497 7.375 5.99997 7.4375 6.18747 7.4375C6.43747 7.4375 6.49997 7.375 6.62497 7.25L9.12497 4.75C9.37497 4.5 9.37497 4.125 9.12497 3.875C8.87497 3.625 8.49997 3.625 8.24997 3.875L6.24997 5.9375L5.43747 5C5.18747 4.75 4.81247 4.6875 4.56247 4.9375C4.31247 5.1875 4.24997 5.5625 4.49997 5.8125L5.74997 7.25Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTasksDark);
export default __webpack_public_path__ + "static/media/ic-tasks-dark.1502da0707c8ad8995d96f068f1bd870.svg";
export { ForwardRef as ReactComponent };